<script>    
    import { CheckCircleFill } from 'svelte-bootstrap-icons';

    export let stage;
       
</script>
<section class='mb-4'>
    <div class='row mb-2'>
        <div class='col-4 text-center'>
            <div class=''>                
                <span
                    class='border border-2 text-circle mx-auto'
                    class:border-primary='{stage == 1}'
                    class:border-success='{stage > 1}' 
                    class:text-primary='{stage == 1}'
                    class:text-success='{stage > 1}' 
                    class:faint-background='{stage == 1}'
                >

                    <h4 class='m-0'>
                        
                        {#if stage > 1}

                            <span class='text-success'>

                                <CheckCircleFill/>

                            </span>

                        {:else}
                            
                            01                            

                        {/if}

                    </h4>

                </span>
            </div>
        </div>
        <div class='col-4 text-center'>
            <span
                class='border border-2 text-circle mx-auto'
                class:border-primary='{stage == 2}'
                class:border-success='{stage > 2}' 
                class:text-primary='{stage == 2}'
                class:text-success='{stage > 2}' 
                class:faint-background='{stage == 2}'
            >

                <h4 class='m-0'>

                    {#if stage > 2}

                        <span class='text-success'>

                            <CheckCircleFill/>

                        </span>

                    {:else}

                        <small>02</small>

                    {/if}

                </h4>
            
            </span>
        </div>
        <div class='col-4 text-center'>
            <div class=''>                
                <span
                    class='border border-2 text-circle mx-auto'
                    class:border-primary='{stage == 3}'
                    class:border-success='{stage > 3}' 
                    class:text-primary='{stage == 3}'
                    class:text-success='{stage > 3}' 
                    class:faint-background='{stage == 3}'
                >
                    
                    <h4 class='m-0'>

                        {#if stage > 3}

                            <span class='text-success'>

                                <CheckCircleFill/>

                            </span>

                        {:else}

                            <small>03</small>

                        {/if}

                    </h4>

                </span>
            </div>
        </div>
    </div>
    <div class='row'>
        <div class='col-4'>
            <div 
                class='text-center'
                class:text-primary='{stage == 1}'    
                class:fw-bold='{stage == 1}'    
                class:text-success='{stage > 1}'    
            >
                Get app
            </div>
        </div>
        <div class='col-4'>
            <div 
                class='text-center'
                class:text-primary='{stage == 2}'    
                class:fw-bold='{stage == 2}'    
                class:text-success='{stage > 2}'    
                class:text-faint='{stage == 1}'
            >
               Scan QR
            </div>
        </div>
        <div class='col-4'>
            <div 
                class='text-center'
                class:text-primary='{stage == 3}'    
                class:text-success='{stage > 3}'   
                class:text-faint='{stage <= 2}' 
                class:fw-bold='{stage == 3}' 
            >
                Enter code
            </div>
        </div>
    </div>
</section>

<style>   
    .text-circle {
        justify-content: center;
        align-items: center;
        border-radius: 100%;
        text-align: center;
        display: flex;
        width: 70px;
        height: 70px;
        line-height: 70px;
    }
</style>